import { render, staticRenderFns } from "./OctListItem.vue?vue&type=template&id=681d583d&scoped=true&"
import script from "./OctListItem.vue?vue&type=script&lang=js&"
export * from "./OctListItem.vue?vue&type=script&lang=js&"
import style0 from "./OctListItem.vue?vue&type=style&index=0&id=681d583d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d583d",
  null
  
)

export default component.exports